import { Dimensions } from "portal/utils/categoryCollection/image";
import { RefObject, useRef } from "react";
import { useResizeObserver } from "portal/utils/hooks/useResizeObserver";

/** Thumbnail size from a preferred value, capped by the measured content container width. */
export const useProtectedThumbnailSize = (
  preferredThumbnailSize: number
): {
  thumbnailDivRef: RefObject<HTMLDivElement>;
  measuredThumbnailMaxSize: number;
  thumbnailSize: number;
  dimensions: Dimensions;
} => {
  const thumbnailDivRef = useRef<HTMLDivElement>(null);
  const { width: thumbnailMaxWidth } = useResizeObserver(thumbnailDivRef);
  const measuredThumbnailMaxSize = thumbnailMaxWidth || Infinity;
  const thumbnailSize = Math.min(
    preferredThumbnailSize,
    measuredThumbnailMaxSize
  );

  return {
    thumbnailDivRef,
    measuredThumbnailMaxSize,
    thumbnailSize,
    dimensions: {
      width: thumbnailSize,
      height: thumbnailSize,
    },
  };
};
